// Banner
import React from "react";
import useBanner from "./useBanner";
import Banner from "./Components/Banner";

const BannerIndex: React.FC = () => {
  const bannerProps = useBanner();

  return <Banner />;
};
export default BannerIndex;
